export default __webpack_public_path__ + "static/santi-vedri-o-5-e-mzfdxedg-unsplash-e3480bbba6839b8222be47f729409be6.png";